import { mappls } from "mappls-web-maps";
import { useEffect, useRef, useState } from "react";

const MAPPLS_KEY = "vfccvdtdtrwglhnqaudxmysbkzyldratuaid";

const mapplsClassObject = new mappls();

const loadObject = {
  map: true,
  layer: "raster", // Optional Default Vector
  version: "3.0", // Optional, other version 3.5 also available with CSP headers
  libraries: ["polydraw"], // Optional for Polydraw and airspaceLayers
  plugins: ["direction"], // Optional for All the plugins
};

export default function MapplsMap() {
  const mapRef = useRef(null);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  useEffect(() => {
    mapplsClassObject.initialize(MAPPLS_KEY, loadObject, () => {
      const newMap = mapplsClassObject.Map({
        id: "map",
        properties: {
          center: [28.633, 77.2194],
          zoom: 4,
        },
      });

      newMap.on("load", () => {
        setIsMapLoaded(true);
      });
      mapRef.current = newMap;
    });
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
      }
    };
  }, []);

  return (
    <div
      id="map"
      style={{ width: "100%", height: "99vh", display: "inline-block" }}
    >
      {isMapLoaded}
    </div>
  );
}
